import { appleSSO, facebookSSO } from "../shared/sso"
import handleRecaptcha from "shared/handle_recaptcha"
import DetectIframeAndHideSSO from "app/scripts/detect_iframe_and_hide_sso"
import RefreshFormAuthenticityToken from "app/scripts/refresh_form_authenticity_token"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import UnifiedProfileDropdown from "shared/components/unified_profile_dropdown"
import ProsumerHome from "app/components/prosumer_home"
import PlanUpgradeButton from "app/components/plan_upgrade_button"
import FeedbackPrompt from "app/components/feedback_prompt/index.tsx"
import PromoteAppBanner from "app/components/promote_app_banner"
import setupHeaderScrollingAnimation from "app/scripts/setup_header_scrolling_animation"
import SetupUnifiedHeaderDropdown from "shared/scripts/setup_unified_header_dropdown"
import PasswordUnmasking from "shared/scripts/password_un_masking"

Object.assign(window.App.Comps, {
  PlanUpgradeButton,
  UnifiedProfileDropdown,
  FeedbackPrompt,
  PromoteAppBanner,
})

Object.assign(window.App.Scripts, {
  appleSSO,
  facebookSSO,
  handleRecaptcha,
  DetectIframeAndHideSSO,
  RefreshFormAuthenticityToken,
  SetupUnifiedMobileMenu,
  PasswordUnmasking,
  ProsumerHome,
  setupHeaderScrollingAnimation,
  SetupUnifiedHeaderDropdown,
})
